"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgUpdateContractAdmin = void 0;
var json_1 = require("../../../util/json");
var MsgUpdateContractAdmin = /** @class */ (function (_super) {
    __extends(MsgUpdateContractAdmin, _super);
    /**
     * @param admin contract admin
     * @param new_admin new admin
     * @param contract contract address
     */
    function MsgUpdateContractAdmin(admin, new_admin, contract) {
        var _this = _super.call(this) || this;
        _this.admin = admin;
        _this.new_admin = new_admin;
        _this.contract = contract;
        return _this;
    }
    MsgUpdateContractAdmin.fromData = function (data) {
        var _a = data.value, admin = _a.admin, new_admin = _a.new_admin, contract = _a.contract;
        return new MsgUpdateContractAdmin(admin, new_admin, contract);
    };
    MsgUpdateContractAdmin.prototype.toData = function () {
        var _a = this, admin = _a.admin, new_admin = _a.new_admin, contract = _a.contract;
        return {
            type: 'wasm/MsgUpdateContractAdmin',
            value: {
                admin: admin,
                new_admin: new_admin,
                contract: contract,
            },
        };
    };
    return MsgUpdateContractAdmin;
}(json_1.JSONSerializable));
exports.MsgUpdateContractAdmin = MsgUpdateContractAdmin;
//# sourceMappingURL=MsgUpdateContractAdmin.js.map